module.exports = "pegasus_template/assets/blocks/column-lp6-basic.png";